import { render, staticRenderFns } from "./locking.vue?vue&type=template&id=bb26d0d4&"
import script from "./locking.vue?vue&type=script&lang=ts&"
export * from "./locking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports